import { render, staticRenderFns } from "./create-token.vue?vue&type=template&id=4c91f0ae&scoped=true&"
import script from "./create-token.vue?vue&type=script&lang=ts&"
export * from "./create-token.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c91f0ae",
  null
  
)

export default component.exports